import { render } from "./ProductSelectorToast.vue?vue&type=template&id=6b51d770&scoped=true"
import script from "./ProductSelectorToast.vue?vue&type=script&lang=js"
export * from "./ProductSelectorToast.vue?vue&type=script&lang=js"

import "./ProductSelectorToast.vue?vue&type=style&index=0&id=6b51d770&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b51d770"]])

export default __exports__